/*
  Menu naglowka w jednej linii (wlasciciel 14.09: „Kontakt” spadal do drugiego rzedu).
  Gdy gorne pozycje nie mieszcza sie w jednym rzedzie, ostatnie przenosimy do „Więcej”
  (wzorzec priority+). Nic nie znika: kazda pozycja jest albo w menu, albo w „Więcej”.
  Liczymy po prawdziwym ukladzie (czy wszystkie li leza w jednym rzedzie), wiec dziala dla PL i EN,
  dla dowolnie dlugiej nazwy auta w przycisku i dla zmian menu w panelu Shopify.
*/
(function () {
  'use strict';

  var nav = document.querySelector('.header__inline-menu');
  var ul = nav && nav.querySelector(':scope > ul.list-menu--inline');
  if (!ul || ul.querySelector('.evm-menu-wiecej')) return;

  var EN = String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var pozycje = Array.prototype.slice.call(ul.children);
  var strzalka = ul.querySelector('summary .icon-caret');

  var wiecej = document.createElement('li');
  wiecej.className = 'evm-menu-wiecej';
  wiecej.hidden = true;
  wiecej.innerHTML =
    '<header-menu><details>' +
      '<summary class="header__menu-item list-menu__item link focus-inset"><span>' + (EN ? 'More' : 'Więcej') + '</span></summary>' +
      '<ul class="header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup evm-menu-wiecej__lista" role="list"></ul>' +
    '</details></header-menu>';
  if (strzalka) wiecej.querySelector('summary').appendChild(strzalka.cloneNode(true));
  ul.appendChild(wiecej);
  var lista = wiecej.querySelector('.evm-menu-wiecej__lista');

  /* Kopia pozycji do „Więcej”: link zostaje linkiem, rozwijana pozycja staje sie grupa
     (naglowek + jej linki). Identyfikatory zdejmujemy, zeby nie bylo dubli w dokumencie. */
  function wpis(li) {
    var kopia = document.createElement('li');
    var link = li.querySelector(':scope > a');
    if (link) {
      var a = link.cloneNode(true);
      a.className = 'header__menu-item list-menu__item link link--text focus-inset caption-large';
      a.removeAttribute('id');
      kopia.appendChild(a);
      return kopia;
    }
    var tytul = li.querySelector('summary span');
    var podlista = li.querySelector('.header__submenu');
    kopia.className = 'evm-menu-wiecej__grupa';
    var naglowek = document.createElement('p');
    naglowek.className = 'evm-menu-wiecej__naglowek';
    naglowek.textContent = tytul ? tytul.textContent.trim() : '';
    kopia.appendChild(naglowek);
    if (podlista) {
      var u = podlista.cloneNode(true);
      u.className = 'list-menu evm-menu-wiecej__podlista';
      u.removeAttribute('id');
      Array.prototype.forEach.call(u.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
      kopia.appendChild(u);
    }
    return kopia;
  }

  function jedenRzad() {
    var widoczne = Array.prototype.filter.call(ul.children, function (li) { return !li.hidden; });
    if (!widoczne.length) return true;
    var gora = widoczne[0].getBoundingClientRect().top;
    return widoczne.every(function (li) { return Math.abs(li.getBoundingClientRect().top - gora) <= 2; });
  }

  function uloz() {
    /* Menu schowane (telefon, hamburger) — nic nie przenosimy. */
    if (!nav.getClientRects().length) return;
    pozycje.forEach(function (li) { li.hidden = false; });
    wiecej.hidden = true;
    lista.textContent = '';
    if (jedenRzad()) return;
    wiecej.hidden = false;
    for (var i = pozycje.length - 1; i >= 1 && !jedenRzad(); i -= 1) {
      pozycje[i].hidden = true;
      lista.insertBefore(wpis(pozycje[i]), lista.firstChild);
    }
  }

  /* setTimeout, nie requestAnimationFrame — w karcie w tle rAF nie odpala (linter motywu). */
  var czekaj = 0;
  function pozniej() {
    clearTimeout(czekaj);
    czekaj = setTimeout(uloz, 80);
  }
  window.addEventListener('resize', pozniej);
  /* Nazwa auta w przycisku, jezyk, ikony — kazda zmiana szerokosci sasiadow zmienia miejsce na menu. */
  if (window.ResizeObserver) {
    var obserwator = new ResizeObserver(pozniej);
    Array.prototype.forEach.call(nav.parentElement.children, function (el) { obserwator.observe(el); });
    var auto = document.querySelector('.header__car--desktop');
    if (auto) obserwator.observe(auto);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pozniej);
  uloz();
})();
